import { getConfig } from "@/lib/config";
import type { MatchResultPdfPayload } from "@/lib/match-result-pdf-model";

export type MatchResultRendererRequest =
  | { type: "match-result-render"; payload: MatchResultPdfPayload }
  | { type: "match-result-download"; payload: MatchResultPdfPayload };

export type MatchResultRendererResponse =
  | { type: "match-result-renderer-ready" }
  | { type: "match-result-download-failed" };

export function matchResultRendererDocumentUrl(): string {
  const basePath = getConfig().basePath;
  return `${basePath.endsWith("/") ? basePath : `${basePath}/`}match-result-renderer.html`;
}

export function isMatchResultRendererRequest(data: unknown): data is MatchResultRendererRequest {
  if (typeof data !== "object" || data === null || !("type" in data)) return false;
  const type = (data as { type: unknown }).type;
  return type === "match-result-render" || type === "match-result-download";
}

export function isMatchResultRendererResponse(data: unknown): data is MatchResultRendererResponse {
  if (typeof data !== "object" || data === null || !("type" in data)) return false;
  const type = (data as { type: unknown }).type;
  return type === "match-result-renderer-ready" || type === "match-result-download-failed";
}
